export const en = {
    nav: {
        apartments: 'Apartments',
        location: 'Location',
        payment: 'Payment',
        materials: 'Materials',
        about: 'About Jura',
        contacts: 'Contacts'
    },
    contactForm: {
        title: 'Get in touch with us',
        nameLabel: 'Name',
        emailLabel: 'Email',
        messageLabel: 'Message',
        submitBtn: 'Send'
    },
    footer: {
        phone: 'Phone',
        email: 'Email',
        address: 'Address',
        addressLinkText: 'Varna, Briz',
        copyright: 'Jura RESIDENCE. All rights reserved.'
    },
    home: {
        heroSliderText: 'Where sea meets nature – at the top location of Breeze residential quarter.',
        heroSliderBtn: 'Choose entrance',
        introLeft: 'Stylish and spacious homes for a happy family life',
        introRight: 'The luxurious housing complex named YURA has an excellent location which provides a quick access to the center of the sea capital and to St. St. Konstantin and Helena and Golden Sands resort complexes. Itsclose proximity to bus stations of the city transport system provides a convenient access to all directions.',
        introBtn: 'View more',
        chooseApartments: 'Choose apartment',
        viewParking: 'View parking',
        box1Title: 'Top location',
        box1Text: 'Breeze quarter is one of the most prestigious residential zones of Varna city.',
        box2Title: 'Excellent infrastructure',
        box2Text: 'In close proximity to Vasil Levski and Knyaz Boris I boulevards',
        box3Title: 'Luxury vision',
        box3Text: 'Luxury façade from natural materials and of excellent quality',
        box4Title: 'Close to nature',
        box4Text: 'Apartments neighbouring the Sea Garden and the Park-Memorialof the Bulgarian-Soviet Friendship',
        box5Title: 'A standard for quality',
        box5Text: 'Builders having a wide experience and high quality of the construction materials',
        box6Title: 'Amenities for the dwellers',
        box6Text: 'Underground garages, commercial and office spaces, lifts.',
        quickLink1Title: 'Façade / Materials',
        quickLink1Text: 'Alow-risebuildingwhichisinharmonywithitssurroundings, covering all the requirements for energy efficiency class A',
        quickLink2Title: 'Additional amenities',
        quickLink2Text: 'The apartments are prepared for installation of air-conditioning and for connection to the gas transmission network. Parking problem solved',
        quickLink3Title: 'Cozy apartments',
        quickLink3Text: 'A small number of apartments perentrance–not many neighbours for a good residential comfort. Each one of the apartments offering ane xcellent exposure and an excellent sound insulation.',
        whyJura: 'Reasons to choose YURA Housing Complex:',
        availableApartments: 'Available apartments',
        whyJura1Title: 'High standard, control and guarantees of completion',
        whyJura1Text: 'The overall vision and the good appearance of the building is apriority for us. The property has been designed in compliance with the latest trends in architecture and contemporary construction requirements. The good execution of the communal areas is a pre-condition for a long-term use and quality.',
        whyJura2Title: 'Prestigious location and connectivity',
        whyJura2Text: 'An exclusively easy access–to Vasil Levski Boulevard and Knyaz BorisI Boulevard, with an access to the city transport system in all directions. Premium educational institutions are located near to the building. It neighbours two parks. The Varna Stadium, the Dolphinarium, tennis courts and swimming pools, kindergartens and various food and entertainment establishments are located in close proximity to Yura.',
        whyJura3Title: 'A variety of comfortable apartments',
        whyJura3Text: 'YURA HousingComplexconsistsoffourentrancesandincludes52 apartmentswith an area of 74 to 300 square meters – two-room, three-room, four-room apartments and such having many rooms, each of them with unique characteristics. The small number of apartments, having big premises and all amenities, resemble a one-family house.',
    },
    apartments: {
        position: 'Exposure',
        east: 'East',
        west: 'West',
        north: 'North',
        south: 'South',
        northEast: 'Norteast',
        northWest: 'Northwest',
        southEast: 'Southeast',
        southWest: 'Southwest',
        available: 'Available',
        reserved: 'Reserved',
        sold: 'Sold',
        goToApartments: 'Go to apartments',
        chooseEntrance: 'Choose entrance',
        chooseFloor: 'Choose floor',
        inputNumber: 'Input number',
        chooseType: 'Choose type',
        inputNetArea: 'Input net area',
        inputGrossArea: 'Input gross area',
        inputPosition: 'Input exposure',
        chooseStatus: 'Choose status',
        twoRoom: '2-room',
        threeRoom: '3-room',
        fourRoom: '4-room',
        manyRoom: '{{rooms}}-room',
        priceNegotiable: 'Price negotiable'
    },
    parking: {
        available: 'Available',
        reserved: 'Reserved',
        sold: 'Sold'
    },
    page404: {
        title: '404 Error',
        text: 'The page you are looking for could not be found. Please, choose an option from the navigation above or go to home page.'
    },
    messages: {
        messageSentSuccessfully: 'Your message was sent successfully.',
        errorSendingMessage: 'An error occurred while sending your message. Please try again later or choose another way of contacting us.',
        requiredFields: 'All fields are required',
        invalidUrl: 'Invalid URL'
    },
    general: {
        siteName: 'Yura Housing Complex',
        previousBtn: 'Previous',
        nextBtn: 'Next',
        price: 'Price',
        floor: 'Floor',
        floor_short: 'floor',
        entrance: 'Entrance',
        entrance_short: 'ent.',
        number: 'Number',
        type: 'Type',
        status: 'Status',
        area: 'Area',
        netArea: 'Net area',
        grossArea: 'Gross area',
        apartment: 'apartment',
        maisonette: 'maisonette',
        apartment_plural: 'Apartments',
        parkingLots: 'Parking',
        viewMore: 'View more',
        homeBtn: 'Home',
        home: 'Home',
        basement: 'Basement',
        print: 'Print apartment page'
    }
}



// WEBPACK FOOTER //
// ./src/utils/translations/en.js